// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminLogin_main__\\+BqbP {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  margin: 2rem;
}

.AdminLogin_formContainer__AWGFd {
  padding: 2rem;
  border-radius: 1rem;
  width: 100%;
  max-width: 400px;
  border: 1px solid var(--color-fash-black);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Admin/AdminLogin.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AACD;;AAEA;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,yCAAA;AACD","sourcesContent":[".main {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmin-height: 100dvh;\n\tmargin: 2rem;\n}\n\n.formContainer {\n\tpadding: 2rem;\n\tborder-radius: 1rem;\n\twidth: 100%;\n\tmax-width: 400px;\n\tborder: 1px solid var(--color-fash-black);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `AdminLogin_main__+BqbP`,
	"formContainer": `AdminLogin_formContainer__AWGFd`
};
export default ___CSS_LOADER_EXPORT___;
